import {useMemo} from "react";

export const useSubdomain = () => {
    return useMemo(() => {
        const { hostname } = window.location;
        const parts = hostname.split(".");
        return parts.length > 2 ? parts[0] : null;
    }, []);
};